class learningObjetivesServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/learning-objectives/:route',{},{
			getLearningObjetives:{
				method:'GET',
				params : {}
			},
			getLearningObjetiveDetails:{
				method:'GET',
				params : {
					route: 'id'
				}
			},
			saveLearningObjetives:{
				method:'POST',
				params : {}
			},
			updateLearningObjetives:{
				method:'PUT',
				params : {}
			},

		});

		return {
			services : services
		};
	}
}

learningObjetivesServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.learningObjetivesServices', [])
.service('learningObjetivesServices', learningObjetivesServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/learningObjetives/learningObjetivesServices.js